import React, { useEffect, useState } from "react";
import { Button, Space, Card, Tabs, Spin, Divider, message } from "antd";
import HeaderSection from "../../components/HeaderSection";
import styled from "styled-components";
import { QuillEditor } from "../../components/QuillEditor";
import { httpRequest } from "../../helpers/api";
import { BaseResponseProps } from "../../types/config.type";

const tnc = "TERMS_AND_CONDITIONS";
const privacyPolicy = "PRIVACY_AND_POLICY";

const tabs = [
	{
		key: tnc,
		label: "Term & Condition",
	},
	{
		key: privacyPolicy,
		label: "Privacy Policy",
	},
];

const Preference: React.FC = () => {
	const [isLoadingAction, setIsLoadingAction] = useState(false);
	const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);

	const [configData, setConfigData] = useState<any>({});

	const [keyTab, setKeyTab] = useState(tnc);

	useEffect(() => {
		fetchList();
	}, []);

	const fetchList = async () => {
		try {
			const resConfig = await httpRequest.get<BaseResponseProps<{ [key: string]: string }>>(
				`/app-configs/custom/as-object?keys=${tnc},${privacyPolicy}`
			);
			setConfigData(resConfig.data.payload);

			setIsLoadingAction(false);
		} catch (error) {
			console.log(error);
			message.error("Something went wrong");
		}
	};

	const updateConfig = async (appConfigKey: string, value: string) => {
		setIsLoadingUpdate(true);
		try {
			const dataToSent = {
				value,
			};
			await httpRequest.patch(`/app-configs/${appConfigKey}`, dataToSent);
			message.success("Updated successfully");

			setIsLoadingUpdate(false);
		} catch (error: any) {
			setIsLoadingUpdate(false);
			console.log(error);
			message.error(error.data.message);
		}
	};

	const handleSubmit = async () => {
		await updateConfig(keyTab, configData[keyTab]);
	};

	const onChangeTab = (key: string) => {
		setKeyTab(key);
	};

	const items = tabs.map((tab) => ({
		label: (
			<div
				className="flex items-center gap-auto"
				style={{
					display: "flex",
					alignItems: "center",
					gap: "auto",
				}}
			>
				{tab.label}
			</div>
		),
		key: tab.key,
		children: (
			<>
				<div className="my-3">
					<QuillEditor
						mode="article-body"
						value={configData[tab.key]}
						onChange={(val) => setConfigData((old: any) => ({ ...old, [tab.key]: val }))}
					/>
				</div>
				<Divider />
			</>
		),
	}));

	return (
		<React.Fragment>
			<Space
				direction="vertical"
				size="large"
			>
				<HeaderSection
					title="Preference"
					subtitle="Manage your content here"
					rightComponent={
						<Button
							type="primary"
							onClick={handleSubmit}
						>
							Update
						</Button>
					}
				></HeaderSection>
				<Spin spinning={isLoadingAction || isLoadingUpdate}>
					<Card
						bordered={false}
						size="small"
					>
						<CustomTabs
							items={items}
							onChange={onChangeTab}
							defaultActiveKey={tabs[0].key}
							activeKey={keyTab}
						/>
					</Card>
				</Spin>
			</Space>
		</React.Fragment>
	);
};
export default Preference;

const CustomTabs = styled(Tabs)`
	.ant-tabs-tab {
		width: 100% !important;
		display: flex;
		justify-content: center;
	}

	.ant-tabs-nav-list {
		width: 100% !important;
	}
`;
